import { createXRStore } from "@react-three/xr";
import { Katana } from "../weapons/Katana";

export const xrStore = createXRStore({
  // No hand-tracking mechanic anywhere in this game (controller-only, per
  // CLAUDE.md). Also works around a bug in the installed @react-three/xr:
  // its default hand touch-pointer passes an already-resolved XRJointSpace
  // object to <XRSpace>, which only recognises joint *names* (strings) and
  // falls through to session.requestReferenceSpace(jointSpaceObject) —
  // "the provided value [object XRJointSpace] is no a valid enum value of
  // type XRReferenceSpaceType." Surfaces when the runtime switches input
  // modality to hands (e.g. player sets controllers down at a result/pause
  // screen). Disabling hand input sidesteps the buggy code path entirely.
  hand: false,
  emulate: {
    controller: {
      left: {
        position: [-0.18, 1.42, -0.35],
        quaternion: [0.14, -0.03, -0.004, 0.989],
      },
      right: {
        position: [0.18, 1.42, -0.35],
        quaternion: [0.14, 0.03, -0.004, 0.989],
      },
    },
  },
  controller: {
    left: Katana,
    right: Katana,
  },
});

// Debug handle, same precedent as window.__sq (src/index.tsx) — lets local
// desktop testing enter the IWER-emulated VR session from DevTools
// (window.__sqXr.enterVR()) while still sitting on the "menu" phase, which
// is the only way to see MenuScreen3D (the world-space menu) without a
// Quest launch: every in-app "Enter VR" trigger (Campaign/Survival start)
// also advances the phase away from "menu" in the same click.
(window as unknown as { __sqXr?: typeof xrStore }).__sqXr = xrStore;
